// extracted by mini-css-extract-plugin
module.exports = {"text-3xl":"airdrop_text-3xl__4fRGS","bg-table-header":"airdrop_bg-table-header__F0qSY","display-scrollbar":"airdrop_display-scrollbar__7k8V9"};